import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer2CzyszczenieDzialek from "../../components/offer/2czyszczenieDzialek";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Oczyszczanie działek pod budowę z zarośli i drzew | Gdańsk, Gdynia, Kaszuby</title>
        <meta name="title" content="Oczyszczanie działek pod budowę z zarośli i drzew | Gdańsk, Gdynia, Kaszuby" />
        <meta
          name="description"
          content="Kompleksowe czyszczenie i oczyszczanie działek z zarośli, krzewów, samosiejek i gruzu pod budowę domów. Działamy w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Oczyszczanie działek pod budowę z zarośli i drzew | Gdańsk, Gdynia, Kaszuby"
        />
        <meta
          property="og:description"
          content="Kompleksowe czyszczenie i oczyszczanie działek z zarośli, krzewów, samosiejek i gruzu pod budowę domów. Działamy w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer2CzyszczenieDzialek />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
